import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GridIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Grid",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.33 2h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33H4.33C3.04 8.99 2 7.95 2 6.66V4.33C2 3.04 3.04 2 4.33 2m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33H4.33C3.04 19.49 2 18.45 2 17.16v-2.33c0-1.29 1.04-2.33 2.33-2.33m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33H4.33C3.04 29.99 2 28.95 2 27.66v-2.33C2 24.04 3.04 23 4.33 23m10.5-21h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33V4.33C12.5 3.04 13.54 2 14.83 2m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33v-2.33c0-1.29 1.04-2.33 2.33-2.33m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33v-2.33c0-1.29 1.04-2.33 2.33-2.33m10.5-21h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33C24.04 8.99 23 7.95 23 6.66V4.33C23 3.04 24.04 2 25.33 2m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33v-2.33c0-1.29 1.04-2.33 2.33-2.33m0 10.5h2.33c1.29 0 2.33 1.04 2.33 2.33v2.33c0 1.29-1.04 2.33-2.33 2.33h-2.33c-1.29 0-2.33-1.04-2.33-2.33v-2.33c0-1.29 1.04-2.33 2.33-2.33"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11 29.28c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v25.14c0 .63-.51 1.14-1.14 1.14M20.14 29.28c-.63 0-1.14-.51-1.14-1.14V3a1.14 1.14 0 1 1 2.28 0v25.14c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 21.28H3A1.14 1.14 0 1 1 3 19h25.14a1.14 1.14 0 1 1 0 2.28M28.14 12.14H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h20.57c1.89 0 3.43 1.54 3.43 3.43v20.57c0 1.89-1.54 3.43-3.43 3.43M5.29 4.14c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H5.29Z"
      })]
    })
  }));
};
GridIcon.displayName = 'GridIcon';